import { Component } from 'react';
import PropTypes from 'prop-types';
import Search from 'Components/Common/SearchBar';
import DropDown from 'Components/Common/DropDown';
import DateTimeRangeComponent from 'Components/Common/DateTimeRangePicker';
import Image from 'Components/Common/Image';
import LoadingOverlay from 'react-loading-overlay';
import { ReactComponent as Audio } from 'assets/images/svg/audiocall.svg';
import { ReactComponent as Missed } from 'assets/images/svg/missed.svg';
import RefreshIcon from 'Components/Common/RefreshIcon';
import DatePickerComponent from 'Components/Common/DateTimePicker';
import CheckBox from 'Components/Common/Input/CheckBox';
import { decryptData } from 'Helpers/cryptLib';
import DurationTitle from 'Components/Common/durationTitle';

export const DEFAULT_PAGE_LIMIT = 10;

const customComponents = {
  Search,
  DropDown,
  DateTimeRangeComponent,
  Audio,
  Missed,
  RefreshIcon,
  DatePickerComponent,
  DurationTitle
};

function dynamicClass(className, options) {
  const Component = customComponents[ className ];
  if (!Component) return null;
  return <Component { ...options } />;
}

export default class DataTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sortby: null,
      descending: null,
      search: false
    };
    this.noData = props.noData || 'No Records found.';
    this.pagination = props.pagination;
  }

  renderSort = (cleanTitle, sortOption) => {
    const { activeSort } = this.props;
    let columnName = cleanTitle+'Sort';
    if(sortOption?.column){
      columnName = sortOption.column+'Sort';
    }
    
    let sortType = '';
    if(columnName === activeSort?.id || columnName === activeSort?.sortBy || cleanTitle === activeSort?.id || cleanTitle === activeSort?.sortBy){
      sortType = activeSort?.value === 'asc' || activeSort?.orderBy === 'asc' ? ' ascending' : ' descending';
    }
    return <span className={ `ctTable_sort${ sortType }` } onClick={ this.onSort }></span>;
  }

  renderTableHeader = () => {
    const { headers, refreshGridTime } = this.props;
    const headerView = headers.map((header, index) => {
      const title = header.title;
      const cleanTitle = header.accessor;
      const width = header.width;
      const { sortOption, cell, chooseOption, headerCell } = header;
      const showComponent = chooseOption?.showComponent || false;
      let sortIcon = this.renderSort(cleanTitle, sortOption);
      if(showComponent) {
        sortIcon = '';
      }
      if(headerCell){
        return <th 
          key={ title }
          ref={ th => {
            this[ title ] = th;
          } }
          style={ { width: width } }
          data-col={ title }
          className={ title == 'checkbox' ? 'w-5' : '' }
        >
          {headerCell()}
          {/* {deleteIcon} */}
        </th>;
      }

      if (!sortOption) {
        return (
          <th
            key={ cleanTitle }
            ref={ th => {
              this[ cleanTitle ] = th;
            } }
            style={ { width: width } }
            data-col={ cleanTitle }
            className={ header.className }
          >
            <span name={ title } data-col={ cleanTitle }>
              {title}
            </span>
          </th>
        );
      }
      const { Component, ...rest } = sortOption;
      const column = sortOption.column || cleanTitle
      return (
        <th
          key={ column }
          ref={ th => {
            this[ column ] = th;
          } }
          style={ { width: width } }
          data-col={ column }
          data-sort={ `${ column }Sort` }
          className={ header.className }
        >
          <span name={ title } data-col={ column }>
            {title}
            {sortIcon}
            {dynamicClass(Component, { ...rest, refreshGridTime })}
          </span>
        </th>
      );
    });
    return headerView;
  };

  renderTableoptions = () => {
    const { headers, refreshGridTime, disableColumnSearch } = this.props;
    if(disableColumnSearch) return null;
    return headers.map((key, index) => {
      const { chooseOption, className } = key;
      if (!chooseOption) return <th key={ index } className={ `${ className }${ key.title == 'checkbox' ? ' w-5' : '' }` }></th>;
      const { Component, showComponent = false, ...rest } = chooseOption;
      if(Component === null) return null;
      if(showComponent) return <th key={ index }></th>;
      return <th key={ index } className={ className }>{dynamicClass(Component, { ...rest, refreshGridTime })}</th>;
    });
  };
  renderContent = () => {
    const { headers, data, profile, className, clickableTR = [] } = this.props;
    return data.map((row, rowIdx) => {
      const id = row[ 'id' ];
      const tds = headers.map((header, index) => {
        const accessors = header.accessor;
        let content = row[ accessors ];
        if(header.isDataEncrypted && (row.username || row.mobileNumber) && content){
          const encryptKey = row.username || row.mobileNumber;
          content = decryptData(content, encryptKey);
        }
        let tooltip = {};
        if(header.tooltip && content){
          tooltip={ tooltip:content };
        }
        let customcontent = '';
        const cell = header.cell;
        if (cell) {
          if (typeof cell === 'object') {
            const dispachFunction = cell.dispachFunction ? cell.dispachFunction : ''
            if (cell.type === 'image' && content) {
              content = <Image style={ cell.style } imageToken={ content } />;
            }
            if (cell.type === 'image-with-name') {
              const splitData = header.combineapidata;
              content = (
                <div className='ctUserInfo' onClick={ () => this.viewImage(dispachFunction, row[ splitData[ 1 ] ]) }>
                  <div className='ctUserInfo_img'>
                    <Image imageToken={ row[ splitData[ 1 ] ] } />{' '}
                  </div>
                  <span className='ctUserInfo_name'>
                      {`${ row[ splitData[ 0 ] ] ? row[ splitData[ 0 ] ] : '' } ${ row[ splitData[ 2 ] ] ? row[ splitData[ 2 ] ] : '' } ` }
                  </span>
                </div>
              );
            }
            if (cell.type === 'icon-with-text') {
              const splitData = header.combineapidata;
              const Component = customComponents[ splitData[ 1 ] ];
              if (!Component) return null;
              content = (
                <div className='user'>
                  <i className='icon'>
                    <Component /> {' '}
                  </i>
                  {row[ splitData[ 0 ] ] } 
                </div>
              );
            }
          } else if (typeof cell === 'function') {
            customcontent = cell({ index, id, rowIdx, content, ...row, profile });
          }
        }
        return typeof cell === 'function' ? (
          customcontent
        ) : (
          <td key={ index } data-row={ rowIdx } className={ header.className }>
            { tooltip?.tooltip ? <div className="data_tooltip" { ...tooltip }><span className='text_ellipsis'>{ content }</span></div> : (content|| '-') }
          </td>
        );
      });
      return <tr onClick={ () => this.onClickTR(clickableTR, row) } className = { className } key={ rowIdx }>{tds || '-'}</tr>;
    });
  };

  /**
   * @method
   * @summary Callback method of onclick on the all sorting icon from the Datatable.
   * @return {Array}
   */
  onSort = (e) => {
    const { sort, col } = e.target.closest('th').dataset;
    if(!sort) return;
    this.props.sortTable(sort, col);
  }

  onClickTR = (clickableTR, row) => {
    if(clickableTR && clickableTR.length > 0) {
      const parameter = clickableTR[ 0 ]?.parameter ? [ row[ clickableTR[ 0 ].parameter ] ] : row;
      [ clickableTR[ 0 ].dispachFunction(parameter) ]
    }
  }

  viewImage = (dispachFunction, imageToken) => {
    if(dispachFunction && dispachFunction !== '') dispachFunction(imageToken);
  }

  renderNoData = () => {
    return <tr><td className='no-data'><div>No Data Available!</div></td></tr>;
  };

  renderTable = () => {
    const headerView = this.renderTableHeader();
    const headerOptions = this.renderTableoptions();
    const contentView =
      this.props.data && this.props.data.length > 0
        ? this.renderContent()
        : this.renderNoData();

    return (
      <form id='searchForm' onSubmit={ event => event.preventDefault() }>
        <div className='ctTableblock'>
          <div className='ctTableblock_wrap'>
            <table className={ `ctTableblock_wrap_ctTable ctTable ctFlexTable ${ this.props.tableClassName }` }>
              <thead>
                <tr>{headerView}</tr>
                <tr className='serach'>{headerOptions}</tr>
              </thead>
              <tbody>{contentView}</tbody>
            </table>
          </div>
        </div>
      </form>
    );
  };
  render() {
    const { loading } = this.props;
    return (
      <>
        <div className='loading-parent'>
          <LoadingOverlay
            active={ loading }
            spinner
            styles={ {
              wrapper: {
                width: '100%',
                textAlign: '-webkit-center'
              },
              overlay: (base) => ({
                ...base,
                position: 'fixed'
              })      
            } }
            text='Please wait...'
          ></LoadingOverlay>

          {this.renderTable()}
        </div>
      </>
    );
  }
}

DataTable.propTypes = {
  /**
   * Contains headers of the Datatable.
   */
  headers: PropTypes.array,
  /**
   * Contains table contents.
   */
  data: PropTypes.array,
  /**
   * Callback method when the table row is clicked.
   */
  rowClickListner: PropTypes.func,
  /**
   * Callback method when the table header sort icon has clicked.
   */
  sortTable: PropTypes.func
};
